import React from 'react';
import { IoPeople, IoCodeWorking, IoCheckmarkCircle, IoGlobe } from 'react-icons/io5';
import { motion } from 'framer-motion';
import AnimatedSection from '../ui/AnimatedSection';

const Stats = () => {
  const stats = [
    {
      icon: <IoPeople className="text-5xl" />,
      number: "5+",
      label: "Happy Clients",
      description: "Satisfied businesses worldwide"
    },
    {
      icon: <IoCodeWorking className="text-5xl" />,
      number: "20+",
      label: "Projects Delivered",
      description: "Successful implementations"
    },
    {
      icon: <IoCheckmarkCircle className="text-5xl" />,
      number: "15+",
      label: "Years Experience",
      description: "Industry expertise"
    },
    {
      icon: <IoGlobe className="text-5xl" />,
      number: "5+",
      label: "Countries Served",
      description: "Global reach"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.9 },
    visible: { 
      opacity: 1, 
      y: 0, 
      scale: 1,
      transition: {
        duration: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="container mx-auto px-4">
        <AnimatedSection>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Experience the Future of IT Today</h2>
            <p className="text-blue-100 text-lg max-w-2xl mx-auto mb-6">
              Schedule a personalized demo with our IT experts and discover how our solutions can be tailored to your specific business needs.
            </p>
            <a
              href="#contact"
              onClick={(e) => scrollToSection(e, 'contact')}
              className="inline-block bg-white text-blue-600 hover:bg-gray-100 font-semibold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Get a Quote
            </a>
          </div>
        </AnimatedSection>
        
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.05, y: -5 }}
              className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-opacity-20 transition-all duration-300 border border-white border-opacity-20"
            >
              <motion.div 
                className="flex justify-center mb-4 text-white"
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.6 }}
              >
                {stat.icon}
              </motion.div>
              <motion.div 
                className="text-5xl font-bold mb-2"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 + 0.3, type: "spring", stiffness: 200 }}
              >
                {stat.number}
              </motion.div>
              <div className="text-xl font-semibold mb-2">{stat.label}</div>
              <div className="text-blue-100 text-sm">{stat.description}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Stats;

